import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'users',
    serviceName: 'unitadmin',
    query: gql`
      query users($ids: [String]) {
        users(ids: $ids) {
          data {
            email
            gender
            is_active
            lastname
            firstname
            birth_date
            national_code
          }
        }
      }
    `,
  },
  update: {
    name: 'updateUser',
    serviceName: 'shopadmin',
    query: gql`
      mutation updateUser(
        $gender: Int
        $is_active: Int
        $email: String
        $lastname: String
        $firstname: String
        $user_ids: [String]!
        $birth_date: String
        $national_code: String
      ) {
        updateUser(
          gender: $gender
          is_active: $is_active
          email: $email
          lastname: $lastname
          firstname: $firstname
          user_ids: $user_ids
          birth_date: $birth_date
          national_code: $national_code
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
